module.exports = __webpack_public_path__ + "static/doodles-dfe01c87e1fb216514c8c8862fec1d76.jpg";